<template lang="pug">
.qrbty
  svg.code(width="300", height="300", shape-rendering="geometricPrecision", xmlns="http://www.w3.org/2000/svg", :viewBox="`0 0 ${ size * 1.5 }, ${ size * 1.5 }`")
    path.white(:fill="bg", :d="`M0,0 h${ size }v${ size }H0z`")
    //circle(:cx="zoom", :cy="zoom", :r="zoom * 2")
    rect.dot(v-for="module in modules", v-bind="module", r="1", :width="zoom", :height="zoom", rx="8")
    g
      rect.mask(:x="scaled(0)", :y="scaled(0)", :width="scaled(7)", :height="scaled(7)", :fill="bg")
      rect(:x="scaled(0)", :y="scaled(0)", :width="scaled(7)", :height="scaled(7)", :fill="fg", :rx="zoom")
      rect.mask(:x="scaled(1)", :y="scaled(1)", :width="scaled(5)", :height="scaled(5)", :fill="bg", :rx="1000")
      rect(:x="scaled(2)", :y="scaled(2)", :width="scaled(3)", :height="scaled(3)", :fill="fg", :rx="1000")
    g
      rect.mask(:x="scaled(30)", :y="scaled(0)", :width="scaled(7)", :height="scaled(7)", :fill="bg")
      rect(:x="scaled(30)", :y="scaled(0)", :width="scaled(7)", :height="scaled(7)", :fill="fg", :rx="zoom")
      rect.mask(:x="scaled(31)", :y="scaled(1)", :width="scaled(5)", :height="scaled(5)", :fill="bg", :rx="1000")
      rect(:x="scaled(32)", :y="scaled(2)", :width="scaled(3)", :height="scaled(3)", :fill="fg", rx="1000")
    g
      rect.mask(:x="scaled(0)", :y="scaled(30)", :width="scaled(7)", :height="scaled(7)", :fill="bg")
      rect(:x="scaled(0)", :y="scaled(30)", :width="scaled(7)", :height="scaled(7)", :fill="fg", :rx="zoom")
      rect.mask(:x="scaled(1)", :y="scaled(31)", :width="scaled(5)", :height="scaled(5)", :fill="bg", :rx="1000")
      rect(:x="scaled(2)", :y="scaled(32)", :width="scaled(3)", :height="scaled(3)", :fill="fg", :rx="1000")
    g
      rect.mask(:x="scaled(28)", :y="scaled(28)", :width="scaled(5)", :height="scaled(5)", :fill="bg")
      rect(:x="scaled(28)", :y="scaled(28)", :width="scaled(5)", :height="scaled(5)", :fill="fg", :rx="zoom / 2")
      rect.mask(:x="scaled(29)", :y="scaled(29)", :width="scaled(3)", :height="scaled(3)", :fill="bg", :rx="zoom / 2")
      rect(:x="scaled(30)", :y="scaled(30)", :width="scaled(1)", :height="scaled(1)", :fill="fg", :rx="1000")

  .logo
</template>
<script>
import QR, { ErrorCorrectLevel } from 'qr.js';
import { vuexComputed, lpFromUrl } from '@/helpers';
let shownTimer;
export default {
  name: 'sticker',
  props: {
    // value: { default: 'https://qrl.sh/SLE-420', type: String },
    // value: { default: 'https://weaveauth20211001193329.azurewebsites.net/api/scanned?lp=tes-003', type: String },
    //value: { default: 'https://h.weave.ai/api/scanned?lp=tes-003', type: String },
    // value: { default: 'https://auth-tmp3.qrl.sh/tes-408;weave.ai', type: String },
    value: { default: 'https://auth-tmp3.qrl.sh/tes-408;weave.ai', type: String },
    compliance: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...vuexComputed('authStatus', 'showProfile', 'au'),
    bg() {
      return 'white';
    },
    fg() {
      const brn = '#8D6E4F';
      return brn;
      // return 'black';
      // return '#5cc199';
    },
    zoom() {
      return 16;
    },
    size() {
      return 36 * this.zoom;
      // return 33 * this.zoom;
    },
    modules() {
      // const { modules } = qr('https://greenlit.la');
      // console.log(ErrorCorrectLevel);
      const { zoom, value } = this;
      const { modules } = new QR(value, { typeNumber: -1, errorCorrectLevel: ErrorCorrectLevel.H });
      // console.log('modules', modules);
      return modules.reduce((array, row, y) => {
        row.forEach((cell, x) => {
          if (cell && !behindLogo(x, y)) {
            array.push({ x: x * zoom, y: y * zoom });
          }
        });
        return array;
      }, []);
      function behindLogo(x, y) {
        return 18 <= y && y <= 21 && 8 <= x ||
          (8 <= x && x <= 12 && 18 <= y && y <= 24);
        // return 17 <= y && y <= 23 && 8 <= x ||
        //   (8 <= x && x <= 12 && 17 <= y && y <= 25);
        //return false && 17 <= y && y <= 23 && 8 <= x || (8 <= x && x <= 12 && 17 <= y && y <= 25);
      }
    },
    forAuth() {
      return /^https\:\/\/auth/i.test(this.value);
    }
  },
  methods: {
    scaled(value) {
      return value * this.zoom;
    }

  },
  mounted() {
    const { value, forAuth, au } = this;
    const lp = lpFromUrl(value);
    // console.log('qr mounted', lp, value);
    if (lp && forAuth && !au?.nt) {
      const shown = async () => {
        let json;
        if (this.showProfile) {
          const eg = (/[\?\;\&]eg\=([^\;]+)/.exec(window.location.search || '') || [])[1] || '';
          // const response = await fetch(`https://h.weave.ai/api/shown?lp=${ lp }&w=${ eg }`);
          const response = await fetch(`https://h.weave.ai/api/shown?lp=${ lp }`, { referrerPolicy: 'no-referrer-when-downgrade' });
          json = await response.json();
        }
        // console.log('qr shown', json);
        const { status, authUser = {} } = json || {};
        if (status) {
          this.authStatus = status;
        }
        if (status === 'h') {
          //todo: store nt;
          console.log('auth success', json);
          this.au = authUser;
          setTimeout(() => (this.showProfile = false), 2500);
        } else {
          shownTimer = setTimeout(shown, 1500);
        }
      };
      shownTimer = setTimeout(shown, 1500);
    }
  }
};
</script>
<style scoped lang="scss">
//@import '../assets/styles/app';
@import '../scss/global';
.qrbty {
  position: relative;
  //top: 1rem;
  //left: 1rem;
  //margin: 1rem;
  width: 10rem;
  height: 10rem;
  .logo {
    cursor: pointer;
    margin: 0.35rem;
    //background-color: white;
    width: 55px;
    height: 55px;
    border-radius: 0.5rem;
    position: absolute;
    top: 6rem;
    left: 6rem;
    transform: scale(2);
    //border: 1px solid $brn;
    //@include large {
    //  margin: 0 0.35rem;
    //  border-color: transparent;
    //}
    //@include small {
    //  &.twoFilters {
    //    opacity: 0;
    //  }
    //}
    &::before {
      position: absolute;
      top: 28%;
      left: -18%;
      content: '\00a0';
      display: inline-block;
      //opacity: 0.25;
      box-shadow: 0 0 4px white,
                  0 0 4px white,
                  0 0 4px white,
                  0 0 4px white,
                  0 0 4px white;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      //position: relative;
      background: no-repeat center top
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 208 208' version%3D'1.2'%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'104' fill%3D'%23e1e1e1'/%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'92.34' stroke%3D'%238d6e4f' stroke-width%3D'5' fill%3D'%238d6e4f'/%3E%3Cpath d%3D'M83.19,149.46c1.67,4.73-1.06,8.6-6.07,8.6H63.43a13.88,13.88,0,0,1-12.17-8.6L25,75.45c-1.68-4.73,1.05-8.6,6.07-8.6H44.75a13.87,13.87,0,0,1,12.17,8.6Z' fill%3D'white'/%3E%3Cpath d%3D'M58.44 149.46c-1.68 4.73 1.06 8.6 6.07 8.6h13.68a13.86 13.86 0 0 0 12.17-8.6l26.27-74c1.68-4.73-1.06-8.6-6.07-8.6H96.88a13.86 13.86 0 0 0-12.17 8.6zm65.37 0c-1.68 4.73 1 8.6 6.07 8.6h13.68a13.88 13.88 0 0 0 12.17-8.6l26.26-74c1.68-4.73-1.05-8.6-6.07-8.6h-13.68a13.87 13.87 0 0 0-12.17 8.6z' fill%3D'%23e1e1e1'/%3E%3Cpath d%3D'M150.07,149.46c1.68,4.73-1,8.6-6.07,8.6H130.32a13.87,13.87,0,0,1-12.17-8.6l-26.27-74c-1.67-4.73,1.06-8.6,6.08-8.6h13.68a13.88,13.88,0,0,1,12.17,8.6Z' fill%3D'white'/%3E%3C/svg%3E");
      //      url('data:image/png;base64,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');
      background-size: contain;
    }
    &::after {
      content: 'weave.ai';
      //content: '';
      position: absolute;
      top: 21%;
      //left: 80%;
      left: 86%;
      transform: translate3d(-50%, 0.5rem, 0);
      font-size: 0.6rem;
      //color: $brn;
      //color: white;
      color: rgba($brn, 0.15);
      padding-left: 0.45rem;
      padding-right: 0.5rem;
      //background-color: rgba($brn, 0.15);
      border-radius: 0.25rem;
      font-weight: 400;
      animation: hide-animation 900ms infinite;
      @keyframes hide-animation {
        0% {
          opacity: 0.95;
        }
        50% {
          opacity: 0.95;
        }
        55% {
          //opacity: 0.85;
        }
        90% {
          opacity: 1;
        }
        100% {
          opacity: 1;
        }
      }
    }
    &.engage {
      &::after {
        content: 'engage'
      }
    }
  }
  svg.code {
    margin: 1rem;
    rect.dot {
      opacity: 0.7;
      fill: $brn;
    }
    g {
      rect:not(.mask) {
        opacity: 0.5;
        //opacity: 0.7;
      }
    }
  }
}
</style>
<style lang="scss">
.sticker {
  .matte {
    svg {
      width: 70px !important;
      height: 70px !important;
    }
  }
  &.compliance {
    img.bg {
      width: 24px;
    }
    .matte {
      svg {
        width: 60px !important;
        height: 60px !important;
      }
    }
  }
}
</style>
